import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile, login as loginAPI, register as registerAPI } from "services/api/auth";
import { Master } from "types";
import { LoginPayload, RegistrationPayload } from "types/auth";
import { User } from "types/user";
import { setAuthorization } from "utils/axiosClient";
import { setCookie } from "utils/cookie";
import { getErrorMessage, isFresh } from "utils/helpers";
import { AuthState } from "./reducer";
import apiConfig from "constants/apiConfig";
import { getBackendTokenForFirebase } from "services/api/chat";

export const login = createAsyncThunk<string, LoginPayload, {rejectValue: string}>(
    'auth/login',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await loginAPI(payload); 
            if(!response.token) throw new Error("Login failed!");
            setCookie('hubAuthToken', response.token,  {
                expires: 180,
                path: '/',
                secure: true,
                sameSite: 'Strict'
            });
            setAuthorization(response.token);
            return response.token
        } catch (error) {
            console.log('error', error);
            return rejectWithValue(getErrorMessage(error, 'Login failed!'));
        }
    }
)

export const register = createAsyncThunk<string, RegistrationPayload, {rejectValue: string}>(
    'auth/register',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await registerAPI(payload);
            if (!response.token) throw new Error("Registration failed!");
            setCookie('hubAuthToken', response.token, {
                expires: 180,
                path: '/',
                secure: true,
                sameSite: 'Strict'
            });
            setAuthorization(response.token);
            return response.token;
        } catch (error) {
            console.log('error', error);
            return rejectWithValue(getErrorMessage(error, 'Registration failed!'));
        }
    }
)

export const fetchUser = createAsyncThunk<{user: User, master: Master}, void, {rejectValue: string}>(
    'auth/fetch-user',
    async (_, {rejectWithValue}) => {
        try {
            const response = await fetchUserProfile();
            return response;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch user profile!'));
        }
    }
)


export const fetchFirebaseBackendTokenThunk = createAsyncThunk<{token: string, hubId: string}, boolean, {rejectValue: string}>(
    'auth/firebase-token',
    async (force: boolean, {rejectWithValue, getState}) => {
        try {
            const state = getState() as {auth: AuthState};
            const selectedHubId = state.auth.selectedHubId;
            const STALE_TIME = apiConfig.CREATE_FIREBASE_TOKEN.staleTime;
            if(!selectedHubId) throw new Error("No hub selected!")
            if(!force && state.auth.firebase_tokens[selectedHubId] && isFresh(state.auth.firebase_tokens[selectedHubId]?.generatedAt, STALE_TIME)){
                return {token: state.auth.firebase_tokens[selectedHubId].token, hubId: selectedHubId};
            }
            console.log('force', force);
            const token: string = await getBackendTokenForFirebase(selectedHubId);
            return {token, hubId: selectedHubId};            
        } catch (error) {
            return rejectWithValue('Failed to login to firebase!');
        }
    }
)
